import React, { useState } from 'react';
import { useGLTF } from '@react-three/drei';
import { Color } from 'three';
import { SceneObject } from '../../../types';

interface ModelObjectProps {
  object: SceneObject;
  isSelected: boolean;
  deviceData?: any;
  visualizationMode: string;
  showDataLabels: boolean;
  showHeatmap: boolean;
}

export const ModelObject: React.FC<ModelObjectProps> = ({ object, isSelected }) => {
  const [hovered, setHovered] = useState(false);

  // Get model path from object
  const modelPath = object.name === 'fallback-model' ? '/fallback-model.glb' : '/models/default.glb';

  // Load the GLTF model
  const { scene } = useGLTF(modelPath);

  // Color tint based on state
  const tintColor = new Color(isSelected ? '#00ff88' : hovered ? '#88ff88' : '#ffffff');

  return (
    <group
      position={object.position as [number, number, number]}
      rotation={object.rotation as [number, number, number]}
      scale={object.scale || [1, 1, 1]}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
    >
      <primitive object={scene.clone()} scale={1} />

      {/* Tint overlay for selection/hover */}
      {(isSelected || hovered) && (
        <mesh>
          <boxGeometry args={[2, 2, 2]} />
          <meshBasicMaterial color={tintColor} transparent opacity={0.2} wireframe />
        </mesh>
      )}
    </group>
  );
};
